import React from 'react';
import Uganda1_ordinary_secondary_subjects from './uganda1_ordinary_secondary_subjects';

const Uganda1_ordinary_secondary = () => {
  return (
    <div>
      <Uganda1_ordinary_secondary_subjects />
    </div>
  );
}

export default Uganda1_ordinary_secondary;
